var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * PersonFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconPersonFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.0002 1.10498C8.78456 1.10498 6.17773 3.7118 6.17773 6.92748C6.17773 10.1432 8.78456 12.75 12.0002 12.75C15.2159 12.75 17.8227 10.1432 17.8227 6.92748C17.8227 3.7118 15.2159 1.10498 12.0002 1.10498ZM12.0001 14.3589C9.69542 14.3589 7.45033 15.0907 5.58845 16.4489C3.72656 17.8071 2.34408 19.7215 1.64032 21.9161C1.56716 22.1442 1.60739 22.3935 1.74858 22.5871C1.88977 22.7806 2.11493 22.8951 2.3545 22.8951H21.6456C21.8852 22.8951 22.1103 22.7806 22.2515 22.5871C22.3927 22.3935 22.4329 22.1442 22.3598 21.9161C21.656 19.7215 20.2735 17.8071 18.4117 16.4489C16.5498 15.0907 14.3047 14.3589 12.0001 14.3589Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconPersonFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconPersonFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconPersonFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-person-filled') === undefined) {
    customElements.define('cat-icon-person-filled', BlocksIconPersonFilled);
}
